module.exports = __webpack_public_path__ + "static/media/remove.29969ac1.svg";